import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { user } from '@/mocks/data/general/user'

import { contentType } from '@/utils/app/request'
import { api } from '@/utils/constants'

import { User, UserUpdatePayload } from '@/types/user'

export const updateUser = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.user.PROFILE}`,
    async ({ request }) => {
        const contentTypeHeader = request.headers.get('content-type')

        // Check if the data is an image
        if (contentTypeHeader.includes(contentType.FORM_DATA)) {
            const form = await request.formData()
            const avatar = form.get('avatar')

            if (!(avatar instanceof File)) {
                return new HttpResponse()
            }

            return HttpResponse.json<User>(user)
        }

        const payload = await request.json()
        const payloadParsed = UserUpdatePayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<User>({
            ...user,
            ...payloadParsed.data,
        })
    },
)
